var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-10-10
 * @brief SEI 랜딩 Header 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { detail, detailList, headerSettingState, headerUserInfoState, loadingBoxState, marketWork, urlState, } from "../../../recoil/menuState";
import { communityPageState, demo, userInfoLoginState, userInfoState } from "../../../recoil/userState";
import CmmConfirmPop2 from "../../../components/common/popup/CmmConfirmPop2";
import LandingPop from "../../../components/common/popup/LandingPop";
import { alertState, confirmState, noneUrl } from "../../../recoil/assessmentState";
import { langId, langState } from "../../../recoil/langState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import * as i18n from "../../../utils/langs/i18nUtils";
import * as USERUTIL from "../../../utils/user/userUtils";
import SideBar from "@layout/header/main/SideBar";
import { handleClickOutside } from "@utils/ClickUtils";
import { useTrans } from "../../../utils/langs/useTrans";
export default function Header(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const [recoilUrlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    const [langIds, setRecoilLangIds] = useRecoilState(langId);
    const setRecoilUserInfo = useSetRecoilState(userInfoState);
    const setRecoilDetailList = useSetRecoilState(detailList);
    const setRecoilMarkerWorks = useSetRecoilState(marketWork);
    const [communityState, setCommunityPageState] = useRecoilState(communityPageState);
    const [details, setDetils] = useRecoilState(detail);
    const setRecoilDetail = useSetRecoilState(detail);
    const demos = useRecoilValue(demo);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const [confirm, setConfirm] = useRecoilState(confirmState);
    const [settingPopup, setRecoilSettingPopup] = useRecoilState(headerSettingState);
    const [userInfoPopup, setRecoilUserInfoPopup] = useRecoilState(headerUserInfoState);
    const [logginInfo, setLoginIngo] = useState("lending");
    const uuid = sessionStorage.getItem("uuid");
    const uuid_h = localStorage.getItem("uuid_h");
    const [userId, setUserId] = useState("user@test.com");
    const [userPw, setUserPw] = useState("1234qwer!@");
    useEffect(() => {
        const clickOutside = (e) => {
            handleClickOutside(e, setRecoilSettingPopup, setRecoilUserInfoPopup);
        };
        document.addEventListener("click", clickOutside);
        return () => {
            document.removeEventListener("click", clickOutside);
        };
    }, []);
    //
    const urlList = [
        { name: t("메뉴.메뉴1"), url: CONST.URL_MAIN },
        { name: "What We do", url: CONST.URL_WHATWEDO },
        { name: t("메뉴.메뉴3"), url: CONST.URL_MARKETPLACE },
        { name: t("메뉴.메뉴4"), url: CONST.URL_CONTACTUS },
        { name: t("메뉴.메뉴5"), url: CONST.URL_COMMUNITY },
        { name: t("메뉴.메뉴6"), url: CONST.URL_DOWNLOAD },
    ];
    const [navOpen, setNavOpen] = useState(false);
    const [myInfo, setMyInfo] = useState(false);
    const params = new URLSearchParams(location.search);
    const paramsLagns = params.get("lang");
    useEffect(() => {
        let url = location.pathname == CONST.URL_SEI ? CONST.URL_MAIN : location.pathname;
        let search = location.search.toString();
        // const lagns = search.split("=",)[1]
        let param = paramsLagns == "en" ? url : url;
        if (search != null) {
            if (paramsLagns !== "en") {
                param = param + search;
            }
        }
        if (paramsLagns == "en") {
            if (userInfo.loginInfo.token) {
                let lagn = CONST.STR_LANG_ENG;
                let boolean = false;
                exchgLanguage(lagn, boolean);
            }
            else {
                (() => __awaiter(this, void 0, void 0, function* () {
                    let language = CONST.STR_APILANG_ENG;
                    // let language =  CONST.STR_APILANG_KOR
                    const frontLang = CUTIL.frontLangSet(language);
                    const langId = CUTIL.LangIdSet(frontLang);
                    localStorage.setItem("langId", langId.toString());
                    yield i18n.changeLang(frontLang);
                    setRecoilLangIds(langId);
                    setRecoilLangs(frontLang);
                }))();
            }
        }
        else {
            const lagn = localStorage.getItem(CONST.STR_LANG_I18N) == CONST.STR_LANG_ENG ? CONST.STR_LANG_ENG : CONST.STR_LANG_KOR;
            let boolean = false;
            exchgLanguage(lagn, boolean);
        }
        setRecoilUrlInfo(param);
        // navigate(param);
    }, [location.pathname, location.search, uuid, paramsLagns]);
    useEffect(() => {
        setUserId(langIds < 2 ? "user@test.com" : "euser@test.com");
    }, [langIds]);
    function NavOpen(e) {
        e.preventDefault();
        if (!navOpen) {
            setNavOpen(true);
        }
        else {
            setNavOpen(false);
        }
    }
    function LandingGo(url) {
        return __awaiter(this, void 0, void 0, function* () {
            if (communityState == "WRITE" && location.pathname == CONST.URL_COMMUNITY) {
                if (window.confirm(t("라벨.변경사항이저장되지않을수있습니다"))) {
                    setRecoilUrlInfo(url);
                    navigate(url);
                    localStorage.setItem("loginintro", url);
                    setNavOpen(false);
                    setCommunityPageState("LIST");
                    setDetils(false);
                    setRecoilMarkerWorks("LIST");
                    if (url == recoilUrlInfo) {
                        navigate(0);
                    }
                }
            }
            else {
                setRecoilUrlInfo(url);
                navigate(url);
                localStorage.setItem("loginintro", url);
                setNavOpen(false);
                setCommunityPageState("LIST");
                setRecoilMarkerWorks("LIST");
                setDetils(false);
                if (userInfo.loginInfo.token) {
                    const detailUserInfo = yield USERUTIL.getDetailUserInfoR(userInfo.loginInfo);
                    const apiLang = CUTIL.frontLangSet(detailUserInfo.language);
                    if (localStorage.getItem("langs") !== apiLang) {
                        setRecoilUserInfo(Object.assign(Object.assign({}, userInfo), { 
                            // loginTime: detailUserInfo.loginTime,
                            // userId: detailUserInfo.userId,
                            // email: detailUserInfo.email,
                            // userName: detailUserInfo.userName,
                            // phoneNumber: detailUserInfo.phoneNumber,
                            // companyName: detailUserInfo.companyName,
                            // zoneName: detailUserInfo.zoneName,
                            // department: detailUserInfo.department,
                            // role: detailUserInfo.role,
                            language: detailUserInfo.language }));
                        const params = new URLSearchParams(location.search);
                        const paramsLagns = params.get("lang");
                        // let language = (localStorage.getItem(CONST.STR_LANG_I18N) == CONST.STR_LANG_KOR) ? CONST.STR_APILANG_KOR : CONST.STR_APILANG_ENG
                        const frontLang = CUTIL.frontLangSet(detailUserInfo.language);
                        const langId = CUTIL.LangIdSet(frontLang);
                        localStorage.setItem("langId", langId.toString());
                        // let language =  CONST.STR_APILANG_KOR
                        // const frontLang = CUTIL.frontLangSet(language);
                        yield i18n.changeLang(frontLang);
                        setRecoilLangIds(langId);
                        setRecoilLangs(frontLang);
                    }
                }
                if (url == recoilUrlInfo) {
                    navigate(0);
                }
            }
        });
    }
    function IntroLogin(e) {
        e.preventDefault();
        if (userInfo.loginInfo.token) {
            setRecoilUserInfoPopup(!userInfoPopup);
        }
        else {
            CUTIL.jsopen_Popup(e);
            setLoginIngo("lending");
        }
        setRecoilSettingPopup(false);
        setNavOpen(false);
    }
    // 대쉬보드 로그인 및 모니터링 이동
    function DashBoradGo(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userInfo.loginInfo.token) {
                if (userInfo.companyName == null) {
                    setConfirm(Object.assign(Object.assign({}, confirm), { layerId: "cmm-linkage-join", header: t("라벨.회사찾기"), content: `${t("라벨.SEI대시보드는회사연동회원서비스입니다")} \n ${t("라벨.회사정보만추가입력하고맞춤형전력자산관리")} \n ${t("라벨.서비스와에너지종합컨설팅서비스를받아보세요")}`, leftBtnName: t("라벨.취소"), rightBtnName: t("라벨.추가입력"), rightBtnCallBack: () => __awaiter(this, void 0, void 0, function* () {
                            CUTIL.jsclose_Popup("pop-cmmConfirm1");
                            CUTIL.jsopen_AlertPopup("cmm-linkage-join");
                        }) }));
                    CUTIL.jsopen_Popup(e);
                }
                else {
                    // TODO :: 추후에 url 받는 기준으로 진입하게 수정
                    // if (userInfo.role == CONST.USERROLE_ENGINEER) {
                    //   setRecoilUrlInfo(CONST.URL_TODAYINSPECTION);
                    //   navigate(CONST.URL_TODAYINSPECTION);
                    // } else
                    if (userInfo.role === CONST.USERROLE_NONE) {
                        setRecoilUrlInfo(CONST.URL_HELP);
                        navigate(CONST.URL_HELP);
                    }
                    else {
                        setRecoilUrlInfo(CONST.URL_MONITORING);
                        navigate(CONST.URL_MONITORING);
                    }
                    const detailUserInfo = yield USERUTIL.getDetailUserInfoR(userInfo.loginInfo);
                    if (localStorage.getItem("langs") !== detailUserInfo.language) {
                        navigate(0);
                    }
                }
            }
            else {
                CUTIL.jsopen_Popup(e);
                setLoginIngo("dash");
            }
            setNavOpen(false);
        });
    }
    function userInfoStates(e) {
        setMyInfo(false);
        CUTIL.jsopen_Popup(e);
    }
    function StartGo(e) {
        setRecoilNoneUrlInfo(false);
        setRecoilUrlInfo(CONST.URL_MAIN);
        navigate(CONST.URL_MAIN);
    }
    function ViewGo(e) {
        if (location.pathname !== CONST.URL_MARKETPLACE) {
            navigate(CONST.URL_COMMUNITY);
        }
        setRecoilNoneUrlInfo(false);
        // setRecoilUrlInfo(list.bannerUrl);
        // navigate(list.bannerUrl);
        setRecoilMarkerWorks("LIST");
        setCommunityPageState("LIST");
        setRecoilDetail(false);
        // setRecoilDetailList(null)
    }
    function OpenPop(e) {
        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.체험계정입니다") }));
        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
    }
    function SettingPopup(e, uuid) {
        e.preventDefault();
        localStorage.setItem("uuid_h", uuid);
        setRecoilSettingPopup(!settingPopup);
        setRecoilUserInfoPopup(false);
    }
    // 다국어 설정 변경 및 recoil 상태 변경
    function exchgLanguage(selLang, boolean) {
        return __awaiter(this, void 0, void 0, function* () {
            saveUserLangs(selLang, boolean);
        });
    }
    function saveUserLangs(frontLang, boolean) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilSettingPopup(false);
            if (uuid !== uuid_h || uuid_h == null) {
                localStorage.setItem("langs_s", frontLang);
            }
            if (userInfo.loginInfo.token) {
                const apiLang = CUTIL.apiLangSet(frontLang);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: "/user/setting/language",
                    appQuery: {
                        language: apiLang,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        if (boolean) {
                            navigate(0);
                        }
                        const frontLangs = CUTIL.frontLangSet(apiLang);
                        setRecoilNoneUrlInfo(true);
                        const langId = CUTIL.LangIdSet(frontLang);
                        yield i18n.changeLang(frontLangs);
                        setRecoilLangIds(langId);
                        setRecoilLangs(frontLangs);
                        localStorage.setItem("langId", langId.toString());
                    }
                }
            }
            else {
                const frontLangsApi = CUTIL.apiLangSet(frontLang);
                const frontLangs = CUTIL.frontLangSet(frontLangsApi);
                const langId = CUTIL.LangIdSet(frontLang);
                // need error handle
                yield i18n.changeLang(frontLangs);
                setRecoilLangIds(langId);
                localStorage.setItem("langId", langId.toString());
                setRecoilLangs(frontLangs);
                if (boolean) {
                    navigate(0);
                }
            }
            setNavOpen(false);
        });
    }
    function moveMypage() {
        if (communityState == "WRITE" && location.pathname == CONST.URL_COMMUNITY) {
            if (window.confirm(t("라벨.변경사항이저장되지않을수있습니다"))) {
                navigate(CONST.URL_MYPAGE);
            }
        }
        else {
            navigate(CONST.URL_MYPAGE);
        }
    }
    const handleClickMenu = (e) => {
        e.preventDefault();
        setRecoilUserInfoPopup(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(LandingPop, { popBody: logginInfo }), _jsx(CmmConfirmPop2, {}), _jsxs("header", Object.assign({ className: "gap-8" }, { children: [details && (_jsx("button", Object.assign({ className: "btn btn-prev", onClick: (e) => ViewGo(e) }, { children: _jsx("span", { children: location.pathname == "/community" || location.pathname == "/mypage" ? t("메뉴.메뉴5") : t("메뉴.메뉴3") }) }))), _jsx("a", Object.assign({ href: "#", className: `navbar__toggleBtn ${navOpen ? "active" : ""}`, onClick: (e) => NavOpen(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC804\uCCB4\uBA54\uB274" })) })), _jsxs("div", Object.assign({ className: "header__left" }, { children: [_jsx("h1", Object.assign({ className: "header__title" }, { children: _jsx("img", { className: "h26", src: require("/static/img/icon_logo_beyondx_service_main.svg"), onClick: (e) => StartGo(e), alt: "beyondX", style: { cursor: "pointer" } }) })), _jsx("ul", Object.assign({ className: "header__menu" }, { children: urlList.map((menu, idx) => (_jsx("li", Object.assign({ onClick: (e) => LandingGo(menu.url), className: `${menu.url == recoilUrlInfo.split("?")[0] ? "active" : ""}` }, { children: _jsx("a", Object.assign({ href: "#", role: "button", tabIndex: 0, onClick: handleClickMenu }, { children: menu.name })) }), "landigWebUrl_" + idx.toString()))) }))] })), _jsx("div", Object.assign({ className: "header__right" }, { children: _jsxs("ul", Object.assign({ className: "header__etc" }, { children: [_jsxs("li", Object.assign({ className: "gap-0" }, { children: [_jsx("a", Object.assign({ href: "#", className: `"btn btn-admin ${userInfoPopup ? "active" : ""}`, "data-pop": "pop-login", onClick: (e) => IntroLogin(e) }, { children: _jsx("span", { children: userInfo.loginInfo.token ? userInfo.userName : t("라벨.로그인") }) })), _jsxs("ul", Object.assign({ className: `header__userinfo header-etc-pop  ${userInfoPopup ? "active" : ""}` }, { children: [_jsx("li", Object.assign({ className: "js-open", "data-pop": "pop-myaccount", onClick: moveMypage }, { children: _jsxs("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: [" ", "My Page"] })) })), _jsx("li", Object.assign({ className: "js-open", "data-pop": "pop-logout_len", onClick: (e) => userInfoStates(e) }, { children: _jsxs("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: [" ", !demos ? "Logout" : t("라벨.체험종료")] })) }))] }))] })), _jsx("li", Object.assign({ className: "js-open", "data-pop": userInfo.companyName == null ? "pop-cmmConfirm1" : "pop1", onClick: (e) => DashBoradGo(e) }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-darkgray" }, { children: _jsx("span", Object.assign({ className: "icon-go" }, { children: t("메뉴.대쉬보드") })) })) }))] })) }))] })), _jsx(SideBar, { urlList: urlList, DashBoradGo: DashBoradGo, LandingGo: LandingGo, navOpen: navOpen, t: t, NavOpen: NavOpen, userId: userId, userPw: userPw })] }));
}
